import type { ReactNode } from 'react';
import { useEffect } from 'react';
import ConfigProvider from 'antd/es/config-provider';
import enUS from 'antd/locale/en_US';
import esES from 'antd/locale/es_ES';
import frFR from 'antd/locale/fr_FR';
import zhCN from 'antd/locale/zh_CN';
import { IntlProvider } from 'react-intl';
import type { SupportedLocale } from './locales';

const antdLocales = {
  en: enUS,
  zh: zhCN,
  fr: frFR,
  es: esES,
} as const;

interface IntlProviderWrapperProps {
  locale: SupportedLocale;
  messages: Readonly<Record<string, string>>;
  children: ReactNode;
}

export function IntlProviderWrapper({ children, locale, messages }: IntlProviderWrapperProps) {
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return (
    <ConfigProvider locale={antdLocales[locale] ?? enUS}>
      <IntlProvider
        locale={locale}
        messages={messages as Record<string, string>}
        defaultLocale="en"
        onError={() => {
          // Suppress missing-translation warnings in production
        }}
      >
        {children}
      </IntlProvider>
    </ConfigProvider>
  );
}
